/**
 * SAVED parent version the editor currently has open, read from the same URL
 * params useSelectedAutoflowVersion maintains (?version=N&versionType=saved).
 * Attached to block-edit requests so the BE stamps the edit's usage rows as
 * {id}:saved:{n} instead of :draft/:live. Undefined when editing the draft.
 */
export const getEditingSavedVersion = (): number | undefined => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('versionType') !== 'saved') {
    return undefined;
  }
  const version = Number(params.get('version'));
  return Number.isNaN(version) ? undefined : version;
};

/** Query-string form for the body-less DELETE endpoints. */
export const getEditingSavedVersionQuery = (): string => {
  const version = getEditingSavedVersion();
  return version === undefined ? '' : `?editing_saved_version=${version}`;
};
